import { render, staticRenderFns } from "./EditLimits.vue?vue&type=template&id=56ae47fa&scoped=true"
import script from "./EditLimits.vue?vue&type=script&lang=js"
export * from "./EditLimits.vue?vue&type=script&lang=js"
import style0 from "./EditLimits.vue?vue&type=style&index=0&id=56ae47fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae47fa",
  null
  
)

export default component.exports